/**
 * Labstep
 *
 * @module components/ProtocolTimer/Action/Menu
 * @desc Action Menu for ProtocolTimer
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import { ProtocolTimerActionEdit } from 'labstep-web/components/ProtocolTimer/Action/Edit';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { IProtocolTimerActionMenuProps } from './types';

export const ProtocolTimerActionMenu: React.FC<
  IProtocolTimerActionMenuProps
> = ({ protocolTimer, type, actions = [] }) => {
  return (
    <ActionMenu
      type={type}
      dataCy="components/ProtocolTimer/Action/Menu"
    >
      {actions.indexOf('edit') > -1 && (
        <ProtocolTimerActionEdit protocolTimer={protocolTimer} />
      )}
      {actions.indexOf('delete') > -1 && (
        <EntityActionDelete entity={protocolTimer} />
      )}
    </ActionMenu>
  );
};

ProtocolTimerActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
